import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router'

import { routes } from '../../../constants/routes'
import { BusinessEntityTabs } from './BusinessEntityTabs'
import { BusinessEntities } from './BusinessEntities'
import { CreateBusinessEntity } from './CreateBusinessEntity'

export const SettingsBusinessEntityRoutes: FC = () => (
  <Switch>
    <Route path={routes.SETTINGS_ENTITIES} exact component={BusinessEntities} />
    <Route path={routes.SETTINGS_ENTITY_CREATE} exact component={CreateBusinessEntity} />
    <Route path={routes.SETTINGS_ENTITY_DETAILS} component={BusinessEntityTabs} />
    <Redirect to={routes.SETTINGS_ENTITIES} />
  </Switch>
)
